<template>
  <picture v-if="isEyecatch">
    <source :srcset="webpImageSrc" type="image/webp" />
    <img v-if="canDisplayWithDimension" v-bind="$attrs" :src="imageUrl" :width="imageWidth" :height="imageHeight" :alt="alt || ''" />
    <img v-else :src="imageUrl" v-bind="$attrs" :alt="alt || ''" />
  </picture>
  <img v-else-if="canDisplayWithDimension" v-bind="$attrs" :src="imageUrl" :width="imageWidth" :height="imageHeight" :alt="alt || ''" />
  <img v-else :src="imageUrl" v-bind="$attrs" :alt="alt || ''" />
</template>

<script>
import { getWebpImageSrc } from '@/utils/eyecatch'
export default {
  props: {
    imageObject: { type: Object, default: null, required: true },
    alt: { type: String, default: null, required: false },
    isFixedDimension: { type: Boolean, default: false, required: false },
    isEyecatch: { type: Boolean, default: false, required: false }
  },
  emits: ['mounted'],
  computed: {
    webpImageSrc() {
      return getWebpImageSrc(this.imageUrl)
    },
    imageUrl() {
      if (!this.imageObject) return ''
      const spUrl = this.imageObject.sp_url || this.imageObject.thumb_url || this.imageObject.url
      return this.$store.isSP ? spUrl : this.imageObject.url
    },
    imageWidth() {
      return this.$store.isSP && this.imageObject.sp_width ? this.imageObject.sp_width : this.imageObject.width
    },
    imageHeight() {
      return this.$store.isSP && this.imageObject.sp_height ? this.imageObject.sp_height : this.imageObject.height
    },
    canDisplayWithDimension() {
      return this.isFixedDimension && this.imageWidth && this.imageHeight
    }
  },
  mounted() {
    this.$emit('mounted', this.imageUrl, this.imageWidth, this.imageHeight)
  }
}
</script>

<style lang="scss" scoped>
img {
  width: 100%;
  height: auto;
  display: block;
}
</style>
